class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverMediaQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.hoverCloseTimer = null;
    this.hoverOpened = false;
    this.boundOpenOnHover = this.openOnHover.bind(this);
    this.boundCloseOnHover = this.closeOnHover.bind(this);
    this.boundCancelHoverClose = this.cancelHoverClose.bind(this);
    this.boundHandleHoverMediaChange = this.handleHoverMediaChange.bind(this);

    this.addEventListener('pointerenter', this.boundOpenOnHover);
    this.addEventListener('pointerleave', this.boundCloseOnHover);
    this.addEventListener('focusin', this.boundCancelHoverClose);
    this.hoverMediaQuery.addEventListener('change', this.boundHandleHoverMediaChange);
  }

  disconnectedCallback() {
    this.cancelHoverClose();
    this.removeEventListener('pointerenter', this.boundOpenOnHover);
    this.removeEventListener('pointerleave', this.boundCloseOnHover);
    this.removeEventListener('focusin', this.boundCancelHoverClose);
    this.hoverMediaQuery.removeEventListener('change', this.boundHandleHoverMediaChange);
  }

  isDesktopPointer(event) {
    return event.pointerType !== 'touch' && this.hoverMediaQuery.matches;
  }

  openOnHover(event) {
    if (!this.isDesktopPointer(event)) return;
    this.cancelHoverClose();

    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && menu.mainDetailsToggle?.open) {
        menu.hoverOpened = false;
        menu.close();
      }
    });

    if (!this.mainDetailsToggle.open) this.hoverOpened = true;
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  }

  closeOnHover(event) {
    if (!this.isDesktopPointer(event)) return;
    if (!this.hoverOpened) return;
    this.cancelHoverClose();
    this.hoverCloseTimer = window.setTimeout(() => {
      if (this.contains(document.activeElement)) return;
      this.hoverOpened = false;
      this.close();
    }, 100);
  }

  cancelHoverClose() {
    window.clearTimeout(this.hoverCloseTimer);
    this.hoverCloseTimer = null;
  }

  handleHoverMediaChange(event) {
    this.cancelHoverClose();
    if (event.matches || !this.hoverOpened) return;

    this.hoverOpened = false;
    this.close();
  }

  onToggle() {
    if (!this.mainDetailsToggle.open) this.hoverOpened = false;
    if (!this.header) return;
    this.header.preventHide = Boolean(this.header.querySelector('header-menu details[open]'));

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
